// extracted by mini-css-extract-plugin
export var backgroundImage = "CruiseCardSummary-module--background-image--21f25";
export var card = "CruiseCardSummary-module--card--9150e";
export var content = "CruiseCardSummary-module--content--fd49f";
export var dates = "CruiseCardSummary-module--dates--a9159";
export var extraContent = "CruiseCardSummary-module--extra-content--3e22b";
export var fareLabel = "CruiseCardSummary-module--fare-label--fe463";
export var imageContainer = "CruiseCardSummary-module--image-container--8878d";
export var lowestFare = "CruiseCardSummary-module--lowest-fare--d7a61";
export var name = "CruiseCardSummary-module--name--e39c6";
export var perGuest = "CruiseCardSummary-module--per-guest--e9613";
export var price = "CruiseCardSummary-module--price--ee839";
export var priceItem = "CruiseCardSummary-module--price-item--ac928";
export var prices = "CruiseCardSummary-module--prices--ef583";
export var pricesColumn = "CruiseCardSummary-module--prices-column--ffbd4";
export var ship = "CruiseCardSummary-module--ship--1bd6c";
export var suiteName = "CruiseCardSummary-module--suite-name--e7ccd";